<template>
  <div class="coach-list-page">
    <header-component></header-component>
    <img  :src="coachBg" alt="coachBg" class="coach-bg">
    <div class="list-content">
      <div class="tabs-header">
        <div :class="['item',0==tabIndex?'active':'']" @click="changeTypeList(0,undefined)">Coaches</div>
        <div :class="['item',1==tabIndex?'active':'']" @click="changeTypeList(1,0)">Saved coach</div>
        <div :class="['item',3==tabIndex?'active':'']" @click="tabIndex=3,showEngagement = true">Engagement</div>
      </div>
      <!-- coach列表内容开始 -->
      <div v-if="!showEngagement" class="list-table-box">
        <!-- 标签区域 -->
       
        <el-collapse accordion style="width: 100%;">
          <el-collapse-item>
            <template slot="title">
              <div class="leapin-primary-huge-button ob-small">Filters</div>
            </template>
            <div class="tags-area">
              <div 
                :class="[
                  'leapin-tags', 
                  'leapin-purple',
                  nowCheckedList.includes(item.value) ? 'checked-tags' : ''
                ]" 
                v-for="(item,index) in tagsList" 
                :key="index"
                @click="searchTagList(item)">
                {{ item.name }}
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
    
        <!-- 列表标题-->
        <div class="table-title">
          <div class="title-top">
            Independent coaches ({{ totalCocahes }})
            <div class="view-button">
              <img :src="linkAir" />View all
            </div>
          </div>
          <div class="title-bottom">
            One step closer to your personal or professional goals.
          </div>
        </div>
        <!-- coach列表 -->
        <div class="coach-list" v-loading="listLoad" ref="scrollableDiv" @scroll="handleScroll">
          <div v-if="coachList.length > 0">
            <div class="cl-item" v-for="(item,index) in coachList" :key="index" @click="showCoachInfo(item)" v-if="item.extra_info != null">
              <el-row :gutter="20">
                <!-- 左侧 -->
                <el-col :span="2" class="cl-item-left">
                  <div class="sign" v-if="item.is_top_match">TOP MATCH</div>
                  <img class="img-avatar" v-if="item.extra_info.avatar != null" :src="item.extra_info.avatar" />
                  <div v-else class="leapin-logo-avatar img-avatar">
                    {{ item.first_name ? item.first_name[0] : '---' }}
                  </div>
                </el-col>
                <!-- 右侧 -->
                <el-col :span="22" class="cl-item-right">
                  <div class="cl-r-title"> 
                    <span class="name">{{ item.first_name }} {{ item.last_name }}</span>
                    <span class="cost">{{ item.extra_info.charge_currency }} - {{ item.extra_info.charge_rate }} </span>
                  </div>
                  <div class="cl-r-info">
                    <el-row :gutter="32" class="leapin-w-100">
                      <!-- <el-col :span="3">
                        <img :src="locationSvg" /> {{ getEmptyBack(item.extra_info.location) }}
                      </el-col> -->
                      <el-col :span="5">
                        <img :src="linkAir" /> <span>{{ getEmptyBack(item.extra_info.work_year) }}</span> Yrs Of Experience
                      </el-col>
                      <el-col :span="4">
                        <img :src="linkAir" /> <span>{{ getEmptyBack(item.extra_info.coach_experience) }}</span> Hrs Coached
                      </el-col>
                    </el-row>
                  </div>
                  <div class="leapin-felx-between leapin-mb-6">
                    <div class="leapin-felx-center">
                      <div class="cl-r-tips" v-for="(e,i) in item.extra_info.target_audience" :key="i">
                        {{ getTargetAudienceList(e)}}
                      </div>
                    </div>
                    <div class="cl-r-button">
                      <div 
                        :class="[
                          'leapin-ob-small',
                          'leapin-light-huge-button',
                          item.extra_info.mark_type == 0 ? 'marked' : ''
                        ]"
                        @click.stop="saveCoach(item,item.extra_info.mark_type)">
                        <img :src="star" /> SAVE
                      </div>
                      <div class="leapin-primary-huge-button leapin-ob-small" @click.stop="hireCoach(item)">
                        <img :src="linkAirWhite" /> HIRE
                      </div>
                    </div>
                  </div>
                  <div class="cl-r-person">
                    <div class="introduce">
                      {{ getEmptyBack(item.extra_info.description) }}
                    </div>
                    <div class="tags">
                      <div class="leapin-tags leapin-blue" v-for="(e,i) in item.specialities" :key="i">
                        {{ e }}
                      </div>
                    </div>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
          <Empty v-else />
        </div>
      </div>

      <!-- engagement -->
       <div v-else class="list-table-box">
        <Engagement></Engagement>
       </div>

    </div>

    <!-- coach详情 -->
    <el-dialog :top="'80px'" :visible.sync="coachDetailVisible" width="1000px">
      <coach-detail :info="coachInfoDetail" @saveCoachDetail="saveCoachDetail" @hireCoachDetail="hireCoachDetail"></coach-detail>
    </el-dialog>


    <!-- 预约弹窗 -->
    <el-drawer
      title="Book an appointment"
      size="60%"
      :visible.sync="drawerShowFalg"
      :direction="direction">
      <CoachBook v-if="drawerShowFalg" :coachId="coachId" @closeBook="drawerShowFalg = false"> 
      </CoachBook>
    </el-drawer>

  </div>
</template>

<script>
import { throttle } from 'lodash';
import {
  getCoachesList,
  markCoach,
} from '@/services/coach'
import { COACH_CODE }  from '@/constants/coachCode'
import { TARGET_AUDIENCE_CODE } from '@/constants/targetAudience'
export default {
  components: {
    HeaderComponent: () => import('@/components/header/Header.vue'),
    CoachDetail: () => import('@/views/coach/detail.vue'),
    CoachBook: () => import('@/views/coach/components/book.vue'),
    Engagement: () => import('@/views/users/EngagementSeeker.vue'),
  },
  name: 'CoachList',
  data() {
    return {
      showEngagement: false,
      pageNum: 1, // 当前页码
      direction: 'rtl',
      drawerShowFalg: false,
      nowCheckedList: [], // 当前选中的标签
      tabIndex: 0,
      coachInfoDetail: {
        extra_info: {}
      },
      listLoad: false,
      coachDetailVisible: false,
      coachBg: require('@/assets/images/coach/coach-bg.png'),
      tagsList: COACH_CODE,
      targetAudienceList: TARGET_AUDIENCE_CODE,
      linkAir: require('@/assets/svgs/link-air.svg'),
      linkAirWhite: require('@/assets/svgs/link-air-white.svg'),
      star: require('@/assets/svgs/star.svg'),
      infoSvg: require('@/assets/svgs/info.svg'),
      locationSvg: require('@/assets/svgs/location.svg'),
      coachList: [],
      totalCocahes: 0,
      seachParams: {
        coach_type: undefined,
        mark_type: undefined
      },
      coachId: 0
    }
  },
  mounted () {
    this.getList()  // 获取列表
    const scrollableElement = this.$refs.scrollableDiv;
    scrollableElement.addEventListener('scroll', this.handleScroll);
  },
  methods: {
    getTargetAudienceList (value) {
      let target = this.targetAudienceList.find(item => item.value == value)
      return target ? target.name : ''
    },
    loadMore() {
      // 加载更多的逻辑...
      //console.log('Loading more items...');
      if (this.coachList.length >= this.totalCocahes) {
        return;
      }
      this.pageNum++
      this.getList()
    },
    handleScroll: throttle(function() {
      const scrollableElement = this.$refs.scrollableDiv;
      if (scrollableElement.scrollHeight - scrollableElement.scrollTop === scrollableElement.clientHeight) {
        // 触发加载更多
        this.loadMore();
      }
    }, 500),// 节流函数，200ms 内最多执行一次
    hireCoachDetail (id) {
      this.coachId = id
      this.coachDetailVisible = false
      this.drawerShowFalg = true
    },
    saveCoachDetail () {
      //this.coachDetailVisible = false
      this.pageNum = 1
      this.getList()
    },
    //book Coach
    hireCoach (e) {
      this.coachId = e.id
      this.drawerShowFalg = true
    },
    // 标记coach
    saveCoach (item,type) {
      let parmas = {
        coach_id: item.id,
        mark_type: type == 0 ? 1 : 0 // 1, # 标记类型 0: 喜欢 1: 不喜欢
      }
      markCoach(parmas).then(res => {
        if (res.code === 0) {
          this.$message.success('Operation succeed')
          this.pageNum = 1
          this.getList()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    showCoachInfo(item) {
      console.log(JSON.stringify(item))
      this.coachInfoDetail = item
      this.coachDetailVisible = true
    },
    changeTypeList (index, type) {
      this.showEngagement = false
      this.tabIndex = index
      this.seachParams.mark_type = type
      this.pageNum = 1
      this.getList()
    },
    searchTagList (item) {
      // 查找ID在数组中的索引
      const index = this.nowCheckedList.indexOf(item.value);
      if (index > -1) {
        // 如果ID存在，则删除
        this.nowCheckedList.splice(index, 1);
      } else {
        // 如果ID不存在，则添加
        this.nowCheckedList.push(item.value);
      }
      this.seachParams.coach_type = this.nowCheckedList.length > 0 ? this.nowCheckedList.join(',') : undefined
      this.pageNum = 1
      this.getList()
    },
    getList () {
      this.listLoad = true
      this.seachParams.page = this.pageNum
      this.seachParams.page_size = 10
      let params = JSON.parse(JSON.stringify(this.seachParams))
      if (this.tabIndex == 1) {
        params.ordering = 'fix_time'
      }
      getCoachesList(params).then(res => {
        this.listLoad = false
        if (res.code === 0) {
          this.coachList = this.pageNum == 1 ? res.data.results : this.coachList.concat(res.data.results)
          this.totalCocahes = res.data.count
        } else {
          this.$message.error(res.message)
        }
      }).catch(err => {
        this.listLoad = false
        this.$message.error(err)
      })
    }
  },
  beforeDestroy() {
    const scrollableElement = this.$refs.scrollableDiv;
    scrollableElement.removeEventListener('scroll', this.handleScroll);
  }
}
</script>
<style scoped lang="scss">
.coach-list-page {
  background: linear-gradient(90deg, #F8F3F0 16.29%, #FBF3F0 51.61%, #FDF6F8 83.83%);
  position: relative;
  min-height: 100vh;
  .checked-tags {
    background: #6E62E5 !important;
    color: #fff !important;
  }
  .coach-bg {
    position: absolute;
    top: 80px;
    width: 100%;
    height: 266px;
    object-fit: cover;
    z-index: 1;
  }
  .list-content {
    padding-top: 80px;
    margin: 0 120px;
    position: relative;
    z-index: 9;
    // height: calc(100vh - 80px);
    // overflow-x: hidden;
    // overflow-y: scroll;
    .tabs-header {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 0 32px;
      margin: 20px;
      color: #FFF;
      .item {
        cursor: pointer;
        font-size: 18px;
        font-weight: 600;
        padding: 16px 32px;
        border-radius: 100px;
        width: 120px;
        text-align: center;
      }
      .active {
        background: #6E62E5 !important;
        &:hover {
          background: #4E3F9E;
        }
      }
    }
    .list-table-box {
      position: relative;
      z-index: 9;
      padding: 32px;
      border-radius: 32px;
      background: #FFF;
      .ob-small {
        height: 28px !important;
        img {
          width: 14px;
          height: 14px;
        }
      }
      .tags-area {
        display: flex;
        align-items: center;
        gap:  10px;
        justify-content: flex-start;
        flex-wrap: wrap;
        padding-bottom: 20px;
        border-bottom: 1px solid #eee;
      }
      .table-title {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 12px;
        align-self: stretch;
        padding: 12px 0;
        border-bottom: 1px solid #eee;
        .title-top {
          color: #000;
          font-size: 20px;
          font-weight: 600;
          font-family: "PingFang SC";
          .view-button {
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            margin: 0 6px;
            display: inline-block;
            width: fit-content;
            color: #6E62E5;
            font-family: "PingFang SC";
            font-size: 14px;
            padding: 4px 12px;
            border-radius: 100px;
            border: 1px solid #6E62E5;
            img {
              width: 18px;
              height: 18px;
              margin-right: 8px;
            }
          }
        }
        .title-bottom {
          color: #000;
          font-size: 14px;
          font-family: "PingFang SC";
        }
      }
      .coach-list {
        display: grid;
        gap: 20px;
        margin-top: 20px;
        height: calc(100vh - 400px);
        overflow-x: hidden;
        overflow-y: scroll;
        .marked {
          background: #e9e8fa !important
        } 
        .cl-item {
          cursor: pointer;
          background: #fcfbfc;
          border-radius: 30px;
          padding: 20px 20px 0;
          position: relative;
          font-family: "PingFang SC";
          margin-bottom: 12px;
          .cl-item-left {
            text-align: right;
            .sign {
              color: #000;
              font-size: 11px;
              font-weight: 400;
              display: flex;
              padding: 6px 14px;
              justify-content: center;
              align-items: center;
              gap: 10px;
              border-radius: 16px 0px 16px 0px;
              background: var(--Color, #FFDA52);
              position: absolute;
              top: -32px;
              left: -22px;
            }
            .img-avatar {
              color: #fff !important;
              width: 55px;
              height: 55px;
              border-radius: 50%;
              display: flex;
              justify-content: center;
              align-items: center;
              font-size: 24px;
            }
          }
          .cl-item-right {
            .cl-r-title {
              margin-bottom: 12px;
              display: flex;
              align-items: center;
              justify-content: space-between;
              .name {
                color: #000;
                font-size: 16px;
                font-weight: 600;
              }
              .cost {
                color: #F70;
                font-size: 20px;
                font-weight: 600;
              }
            }
            .cl-r-info {
              color: #000;
              font-size: 13px;
              font-weight: 600;
              margin-bottom: 10px;
              display: flex;
              justify-content: flex-start;
              align-items: center;
              span {
                color: #6E62E5;
              }
            }
            .cl-r-tips {
              display: inline-block;
              width: fit-content;
              margin-left: 16px;
              color: #999;
              font-size: 14px;
              //margin-bottom: 10px;
            }
            .cl-r-person {
              border-top: 1px solid #eee;
              //border-bottom: 1px solid #eee;
              color: #000;
              font-size: 14px;
              .introduce {
                margin-top: 16px;
                line-height: 18px;
              }
              .tags {
                margin: 10px auto;
                display: flex;
                gap: 10px;
                justify-content: flex-start;
                align-items: center;
              }
            }
            .cl-r-button {
              display: flex;
              justify-content: flex-end;
              align-items: center;
              gap: 0 20px;
            }

          }
        }
      }

    }
  }
  // .el-collapse {
  //   border: none !important;
  // }
}
</style>
<style lang="scss">
.coach-list-page {
  .el-dialog__body{
    padding: 0px;
    border-radius: 30px
  }
  .el-dialog__header {
    padding: 0px;
  }
  .el-dialog {
    border-radius: 30px;
  }
  .el-dialog__headerbtn {
    right: -40px;
    top: -10px;
    font-size: 28px;
    transition: transform 0.5s ease; /* 平滑旋转效果 */
    transform: rotate(0deg); /* 初始旋转角度 */
  }
  .el-dialog__headerbtn:hover {
    transform: rotate(180deg); /* 鼠标悬停时旋转180度 */
  }
  .el-dialog__headerbtn .el-dialog__close {
    color: #fff;
  }
}
</style>
